import React, { useState, useEffect } from 'react'
import { Row, Col, Card, Button, Modal, Form } from 'react-bootstrap';
import { pythonAxiosInstance } from '../../config/ConfigInfo';
import { getItem, setItem } from '../../config/localStorage';
import SpinLoader from '../../component/loader/SpinLoader';

function CertificationsModal(props) {
    const jobTitle = getItem('jobTitle');
    const saveCertificationsData = getItem('certificationsData') ? JSON.parse(getItem('certificationsData')) : '';

    const [certifications, setCertifications] = useState(
        saveCertificationsData ?
            saveCertificationsData :
            [{ certificationsYear: '', certificationsName: '' }]
    );

    const [certificationList, setCertificationList] = useState([]);
    const [searchInput, setSearchInput] = useState('');
    const [loader, setLoader] = useState(true);
    const [error, setError] = useState('');
    const [searchError, setSearchError] = useState('');
    const [success, setSuccess] = useState('');
    const [showAddBtn, setShowAddBtn] = useState((saveCertificationsData ? true : false))
    const [searchToggle, setSearchToggle] = useState(false);


    /** call API to fetch the certification data start */

    useEffect(() => {

        (async () => {
            const raw = {
                job_title: searchInput === '' ? jobTitle : searchInput
            };
            try {
                setLoader(true);
                const response = await pythonAxiosInstance.post('generate-certifications-based-jobtitle/', raw);
                if (response.status === 200) {

                    let updatedCertification;
                    if (saveCertificationsData) {
                        updatedCertification = response.data.certifications.map((list) => {
                            const match = certifications.find((item) => item.certificationsName === list.name);
                            if (match) {
                                return { ...list, disabled: true };
                            }
                            return list;
                        });
                    } else {
                        updatedCertification = response.data.certifications;
                    }

                    setLoader(false);
                    setCertificationList(updatedCertification);
                }
            } catch (error) {
                setError(error.message);
                setLoader(false);
            }
        })()

    }, [searchInput, searchToggle]);

    /** call API to fetch the certification data end */


    const handleCertificationListClick = (item, index) => {
        let copy = [...certifications]
        if (!copy[copy.length - 1].certificationsName) {
            copy[copy.length - 1].certificationsName = item?.trim()
        } else {
            copy = [...certifications, { certificationsYear: '', certificationsName: item?.trim() }];
        }

        let updatedCertificationsList = checkEnableDisablePlus(copy)
        setCertificationList(updatedCertificationsList);

        let isValid = checkValueData(copy)
        if (!isValid) {
            setShowAddBtn(false)
        } else {
            setShowAddBtn(true)
        }
        setCertifications(copy);
    }

    const handleAddField = () => {
        const newCertifications = [...certifications, { certificationsYear: '', certificationsName: '', }];
        setCertifications(newCertifications);
        setShowAddBtn(false)
    };

    const handleRemoveField = (index) => {
        const newCertifications = [...certifications];
        newCertifications.splice(index, 1);
        setCertifications(newCertifications);

        let updatedCertificationsList = checkEnableDisablePlus(newCertifications)
        setCertificationList(updatedCertificationsList);

        const certificationsName = newCertifications.map(item => item.certificationsName?.trim());
        const uniqueCertificationsName = new Set(certificationsName);
        const hasDuplicateCertificationsTitle = certificationsName.length !== uniqueCertificationsName.size;


        let isValid = checkValueData(newCertifications)
        if (!isValid) {
            setShowAddBtn(false)
        } else if (isValid) {
            setShowAddBtn(true)
        } else {
            setShowAddBtn(showAddBtn)
        }
        if(hasDuplicateCertificationsTitle){
            setError("You have inserted the same certifications name!")
        }
        else{
            setError("")
        }

        // setError('');
        setSuccess('');
        setSearchError('');

    };

    const handleChange = (index, event) => {
        const { name, value } = event.target;
        const newCertifications = [...certifications];
        newCertifications[index][name] = value;
        setCertifications(newCertifications);

        let updatedCertificationsList = checkEnableDisablePlus(newCertifications)
        setCertificationList(updatedCertificationsList);

        const certificationsName = newCertifications.map(item => item.certificationsName?.trim());
        const uniqueCertificationsName = new Set(certificationsName);
        const hasDuplicateCertificationsTitle = certificationsName.length !== uniqueCertificationsName.size;
        let isValid = checkValueData(newCertifications)

        if (!hasDuplicateCertificationsTitle && isValid) {
            setShowAddBtn(isValid)
            setError('')
        } else {
            setShowAddBtn(false)
            if (value !== '' && isValid) {
                setError('You have inserted the same certifications name!')
            }
        }
    };

    function checkEnableDisablePlus(newCertifications) {
        const listItemCopy = [...certificationList];
        const updatedList = listItemCopy.map(item => {
            const foundItem = newCertifications.find(copyItem => copyItem.certificationsName === item.name?.trim());
            return {
                ...item,
                disabled: foundItem ? true : false,
            };
        });
        return updatedList;
    }

    function checkValueData(newCertifications) {
        return newCertifications.every((each) => each.certificationsName !== "")
    }

    const handleCertificationSearch = (e) => {
        e.preventDefault();
        setError('')
        setSearchError('');
        setSuccess('');
        if (e.target.elements.searchCertification.value === '') {
            setSearchError('Please enter a job title');
        } else {
            setSearchToggle(!searchToggle);
            setSearchInput(e.target.elements.searchCertification.value);
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setItem('certificationsData', JSON.stringify(certifications));
        setSuccess('Thank you for providing your certification details.');
        setSearchError('');
        setError('')
    };

    const closePopUp = () => {
        setError('')
        setSearchError('');
        setSuccess('');
    };

    return (
        <>
            <Modal
                {...props}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop='static'
            >
                <Modal.Header closeButton onClick={closePopUp}>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Certifications
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <Row>
                        <Col md={6} className='mb-3'>
                            <Col md={12} className='skill-left-section'>
                                <h6 className='text-center mt-2'>Search By Job Title For Pre-Written Examples</h6>
                                <Col md={12} className='ai-search-skill-form'>
                                    <Form onSubmit={handleCertificationSearch}>
                                        <div className='ai-serach-form-section'>
                                            <div className='input-section'>
                                                <Form.Control
                                                    placeholder="Search By Job Title"
                                                    size="lg"
                                                    type='text'
                                                    id="searchCertification"
                                                />
                                            </div>
                                            <div className='button-section'>
                                                <button type="submit" className="search-skill-btn"><i className="fa fa-search"></i></button>
                                            </div>
                                        </div>
                                    </Form>
                                    {
                                        searchError ?
                                            <Col md={12} className='mt-3 d-inline-block w-100'>
                                                <div className="alert alert-danger" role="alert">
                                                    {searchError}
                                                </div>
                                            </Col> : ''
                                    }
                                </Col>
                                <Col md={12} className='mt-3 ai-search-skill-result-part'>
                                    <Card>
                                        <Card.Body>
                                            <Card.Title>Ready-to-use-examples</Card.Title>
                                            <div className='ai-list-item'>
                                                <ul>
                                                    {

                                                        loader === true ? <SpinLoader /> :
                                                            certificationList?.map((item, index) => (
                                                                <li key={item.id} item={item.name} >
                                                                    <div className='button-part'>
                                                                        <Button onClick={() => handleCertificationListClick(item.name, index)} disabled={item.disabled}>
                                                                            <i className="fa fa-plus" aria-hidden="true"></i>
                                                                        </Button>
                                                                    </div>
                                                                    <div className='text-part source-editor-1'>
                                                                        <p>{item.name}</p>
                                                                    </div>
                                                                </li>
                                                            ))
                                                    }
                                                </ul>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Col>
                        </Col>
                        <Col md={6} className='mb-3'>
                            <Col md={12} className='skill-right-section responsive-right-section'>

                                <h4 className='mb-3 fw-bold'>What certifications do you have?</h4>

                                {
                                    certifications.map((field, index) => (
                                        <Col md={12} className='finalize-certification-section mt-4 mb-3' key={index}>
                                            <Row>
                                                <Col md={12} className='responsive-certification-item col-xl-4'>
                                                    <Form.Group controlId="formBasicEmail">
                                                        <Form.Control
                                                            type="date"
                                                            max={new Date().toISOString().split('T')[0]}
                                                            name="certificationsYear"
                                                            placeholder='Your certification year'
                                                            value={field.certificationsYear}
                                                            onChange={(event) => handleChange(index, event)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={certifications.length === 1 ? 12 : 12} className='responsive-certification-item col-xl-7'>
                                                    <Form.Group controlId="formBasicEmail">
                                                        <Form.Control
                                                            type="text"
                                                            name="certificationsName"
                                                            placeholder='Your certification Name'
                                                            value={field.certificationsName}
                                                            onChange={(event) => handleChange(index, event)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                {
                                                    certifications.length > 1 && (
                                                        <Col md={12} className='ps-0 responsive-certification-item col-xl-1'>
                                                            <Button className='btn btn-danger' onClick={() => handleRemoveField(index)}><i className="fa fa-trash"></i></Button>
                                                        </Col>
                                                    )
                                                }
                                            </Row>
                                        </Col>
                                    ))
                                }

                            </Col>
                            <Col md={12} className='text-end mb-3'>
                                <Button className="text-end text-success btn finalize-btn" disabled={!showAddBtn || error!==""} onClick={handleAddField}><i className='fa fa-plus'></i> Add one more</Button>
                            </Col>
                            {
                                error ? <div className="alert alert-danger mt-3" role="alert">{error}</div> : ''
                            }

                            {
                                success ? <div className="alert alert-success mt-3" role="alert">{success}</div> : ''
                            }
                        </Col>

                        <Modal.Footer>
                            <Button className='button-green' type="submit" disabled={!showAddBtn || error!==""} onClick={handleSubmit}>Save changes</Button>
                        </Modal.Footer>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CertificationsModal
